import React, { FocusEvent, memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// components
import { FormControlProps } from '@mui/material';
import OutlinedInput, { IOutlinedInputProps } from 'components/inputs/outlined-input';

interface OwnProps extends IOutlinedInputProps {
  name: string;
  label?: string;
  placeholder?: string;
  withError?: boolean;
  sxControl?: FormControlProps['sx'];
  [x: string]: any;
  readOnly?: boolean;
  disablleMinus?: boolean;
  shouldUnregister?: boolean;
  additionalOnChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const OutlinedInputController: React.FC<OwnProps> = ({
  name = '',
  defaultValue = '',
  withError,
  disablleMinus,
  shouldUnregister = false,
  ...props
}) => {
  const { control } = useFormContext();

  const { additionalOnChange, ...validProps } = props;

  const preventMinus = (e) => {
    if (e.code === 'Minus') {
      e.preventDefault();
    }
  };

  return (
    <Controller
      render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => {
        const handleBlur = (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
          onBlur();

          if (props.onBlur) {
            props.onBlur(e);
          }
        };

        const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
          onChange(e);
          if (additionalOnChange) {
            additionalOnChange(e);
          }
        };

        return (
          <OutlinedInput
            {...validProps}
            name={name}
            value={value}
            error={!!error}
            onBlur={handleBlur}
            onChange={handleChange}
            onKeyPress={disablleMinus ? preventMinus : null}
            helperText={withError ? error?.message || ' ' : ' '}
          />
        );
      }}
      name={name}
      control={control}
      defaultValue={defaultValue}
      shouldUnregister={shouldUnregister}
    />
  );
};

export default memo(OutlinedInputController);
